import React, { Component } from "react";

import { createStore, combineReducers, applyMiddleware } from "redux";
import { Provider } from 'react-redux'
import { composeWithDevTools } from 'redux-devtools-extension';

import reducerCreators from "./actions/reducers/";

import { crashReporter } from "./actions/actionMiddlewares";
import thunk from "redux-thunk";

import createHistory from "history/createHashHistory";
import { routerReducer, routerMiddleware } from 'react-router-redux'

import RootView from "./components/RootView";

const history = createHistory();

const middleWare = applyMiddleware(
    thunk,
    crashReporter,
    routerMiddleware(history)
);

const initWebState = {
    history,
    scrollPosition: {},
    renderedIndex: {},
    isShowLogoutModal: false,

    // 確認視窗
    confirmDialog: {
      isOpen: false,
      title: undefined,
      description: undefined,
      isPromise: false,
      confirmCallback: undefined,
      confirmPromise: undefined,
      cancelCallback: undefined,
      confirmName: undefined,
    },

    // 警告視窗
    alartDialog: {
        isOpen: false,
        title: undefined,
        description: undefined,
        confirmName: undefined,
        callback: undefined,
    },
};

const initAdminState = {
    isLogin: false,
    isCheckingLogin: false,
    isLogouting: false,
    loginInfo: {},
};


const initEmptyInvoiceState = {
    emptyInvoiceList: {},
    emptyInvoices: {},
    pageLen: 20,
    totalCount: 0,
    isGetEmptyInvoiceList: false,
    isAddEmptyInvoice: false,
    isDeleteEmptyInvoice: false,
    querykey: '',
    yearmonthList: [],
};


const initInvoiceState = {
    invoiceList: {},
    invoices: {},
    orderInvoices: {},
    pageLen: 20,
    totalCount: 0,
    isCreateInvoice: false,
    isFailInvoice: false,
    isLoadingInvoiceList: false,
    isLoadingInvoiceInfo: false,
    isLoadingOrderInvoiceInfo: false,
    querykey: '',
    downloadTaxMediaDialog: {
        isOpen: false,
    },
    yearmonthList: [],
};


const initAllowanceState = {
    allowanceList: {},
    allowances: {},
    pageLen: 20,
    totalCount: 0,
    isGetAllowanceList: false,
    isCreateAllowance: false,
    isGetAllowanceInfo: false,
    querykey: '',
};


const initPrizedInvoiceState = {
    prizedInvoiceList: {},
    prizedInvoices: {},
    pageLen: 20,
    totalCount: 0,
    isGetPrizedInvoiceList: false,
    isCheckPrizedInvoice: false,
    querykey: '',
    yearmonthList: [],
};

const initTurnkeyUploadLogState = {
    turnkeyUploadLogList: {},
    turnkeyUploadLogs: {},
    pageLen: 20,
    totalCount: 0,
    isGetTurnkeyUploadLogList: false,
    querykey: '',
    yearmonthList: [],
}

const actionReducers = combineReducers({
    web: reducerCreators.createWebReducers({}),
    admin: reducerCreators.createAdminReducers({}), 
    emptyInvoice: reducerCreators.createEmptyInvoiceReducers({}), 
    invoice: reducerCreators.createInvoiceReducers({}), 
    allowance: reducerCreators.createAllowanceReducers({}), 
    prizedInvoice: reducerCreators.createPrizedInvoiceReducers({}), 
    turnkeyUploadLog: reducerCreators.createTurnkeyUploadLogReducers({}), 
    router: routerReducer

});

let actionStore = createStore(
    actionReducers,
    {
        web: initWebState,
        admin: initAdminState,
        emptyInvoice: initEmptyInvoiceState,
        invoice: initInvoiceState,
        allowance: initAllowanceState,
        prizedInvoice: initPrizedInvoiceState,
        turnkeyUploadLog: initTurnkeyUploadLogState,

    },
    composeWithDevTools(middleWare)
);

class App extends Component {
    render() {
        return (
            <Provider store={actionStore}>
                <RootView />
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js